import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Card, Flex, Heading, LinkButton, Spinner } from 'core/components';
import MetricsConnections from 'app/views/metrics/components/MetricsConnections';
import { isEmpty } from 'lodash';
import MetricConnectionCollection from 'app/stores/metrics/MetricConnectionCollection';

@inject('$hybridMap', '$devices')
@observer
export default class DeviceConnectionsToolResult extends Component {
  state = {
    device: null,
    connectionsCollection: new MetricConnectionCollection(),
    isLoading: true
  };

  componentDidMount() {
    const { tool } = this.props;
    const { raw_result = {} } = tool;

    if (!isEmpty(raw_result)) {
      this.initializeData();
    }
  }

  initializeData = () => {
    const { $devices, tool } = this.props;
    const { raw_result = {} } = tool;
    const { device_name, connections } = raw_result;
    const fetchDevice = $devices.fetchDevice(device_name);

    fetchDevice.then((device) => {
      const { connectionsCollection } = this.state;
      this.setState({ device, isLoading: false });
      connectionsCollection.add(connections);
    });
  };

  render() {
    const { tool, onCloseToolResult } = this.props;
    const { device, connectionsCollection, isLoading } = this.state;
    const { raw_result = {} } = tool;

    if (isEmpty(raw_result)) {
      return null;
    }

    const { device_name } = raw_result;

    if (isLoading) {
      return <Spinner />;
    }

    return (
      <Card
        p={0}
        className="tool-result-connections"
        display="flex"
        flexDirection="column"
        gap={2}
        minHeight={750}
        height="100%"
        overflow="hidden"
      >
        <Flex alignItems="center" justifyContent="space-between" p={2} pb={0}>
          <Heading level={5} m={0} flex={1}>
            {tool.title}
          </Heading>
          <Flex alignItems="center" gap={1}>
            <LinkButton icon="shield" small minimal to={`/v4/infrastructure/devices/${device_name}/connections`}>
              View in Infrastructure
            </LinkButton>
            <Button text="Close" small icon="cross" onClick={() => onCloseToolResult(tool)} color="muted" minimal />
          </Flex>
        </Flex>
        <MetricsConnections
          showTitleBar={false}
          showLocalInterfaceColumn
          collection={connectionsCollection}
          metricsDevice={device}
        />
      </Card>
    );
  }
}
